var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-right"},[(_vm.task.publishedAt)?_c('BaseButton',{attrs:{"danger":"","disabled":_vm.loading},on:{"click":_vm.unpublish}},[_vm._v(" UnPublish ")]):_c('BaseButton',{attrs:{"success":"","disabled":_vm.loading || !_vm.isAssigned},on:{"click":_vm.publish}},[_vm._v(" Publish ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }